import { AsymmetricMessagePayloadType, } from '@standardnotes/models';
import { Result } from '@standardnotes/domain-core';
import { GetReplaceabilityIdentifier } from '../../AsymmetricMessage/UseCase/GetReplaceabilityIdentifier';
export class SendVaultKeyChangedMessage {
    constructor(users, keyManager, _encryptMessage, _findContact, _sendMessage, _getVaultUsers, _getKeyPairs) {
        this.users = users;
        this.keyManager = keyManager;
        this._encryptMessage = _encryptMessage;
        this._findContact = _findContact;
        this._sendMessage = _sendMessage;
        this._getVaultUsers = _getVaultUsers;
        this._getKeyPairs = _getKeyPairs;
    }
    async execute(params) {
        const users = await this._getVaultUsers.execute({ sharedVaultUuid: params.sharedVaultUuid, readFromCache: false });
        if (users.isFailed()) {
            return Result.fail('Cannot send root key changed message; users not found');
        }
        const keys = this._getKeyPairs.execute();
        if (keys.isFailed()) {
            return Result.fail('Cannot send root key changed message; keys not found');
        }
        const errors = [];
        for (const user of users.getValue()) {
            if (user.user_uuid === this.users.sureUser.uuid) {
                continue;
            }
            const trustedContact = this._findContact.execute({ userUuid: user.user_uuid });
            if (trustedContact.isFailed()) {
                continue;
            }
            const result = await this.sendToContact({
                keySystemIdentifier: params.keySystemIdentifier,
                sharedVaultUuid: params.sharedVaultUuid,
                keys: keys.getValue(),
                contact: trustedContact.getValue(),
            });
            if (result.isFailed()) {
                errors.push(result.getError());
            }
        }
        if (errors.length > 0) {
            return Result.fail(errors.join(', '));
        }
        return Result.ok();
    }
    async sendToContact(params) {
        const keySystemRootKey = this.keyManager.getPrimaryKeySystemRootKey(params.keySystemIdentifier);
        if (!keySystemRootKey) {
            throw new Error(`Vault key not found for keySystemIdentifier ${params.keySystemIdentifier}`);
        }
        const message = {
            type: AsymmetricMessagePayloadType.SharedVaultRootKeyChanged,
            data: { recipientUuid: params.contact.contactUuid, rootKey: keySystemRootKey.content },
        };
        const encryptedMessage = this._encryptMessage.execute({
            message: message,
            keys: params.keys,
            recipientPublicKey: params.contact.publicKeySet.encryption,
        });
        if (encryptedMessage.isFailed()) {
            return Result.fail(encryptedMessage.getError());
        }
        const replaceabilityIdentifier = GetReplaceabilityIdentifier(AsymmetricMessagePayloadType.SharedVaultRootKeyChanged, params.sharedVaultUuid, params.keySystemIdentifier);
        const sendMessageResult = await this._sendMessage.execute({
            recipientUuid: params.contact.contactUuid,
            encryptedMessage: encryptedMessage.getValue(),
            replaceabilityIdentifier,
        });
        return sendMessageResult;
    }
}
